import {Grid} from "ag-grid-community";

function initGridForPagination(domElement, finalOptions) {
	new Grid(domElement, finalOptions);

	// Add pagination properties
	finalOptions._pagination = true;
	finalOptions._pages = {};
	finalOptions._currentPage = 0;
	finalOptions._totalPages = 0;

	// Add pagination methods
	finalOptions._refresh = refresh;
	finalOptions._getPage = getPage;
	finalOptions._setPage = setPage;
	finalOptions._renderPage = renderPage;
	finalOptions._updateRowWidths = updateRowWidths;
}

/**
 * Refreshes the pagination grid by cleaning the saved
 * pages and going back to the start
 */
function refresh() {
	this._pages = {};
	this._currentPage = 0;
	this._setPage(0);
}

/**
 * Sets the grid to a page, retrieving the rows
 * from the server if not in memory
 *
 * @param page
 */
function setPage(page) {
	if(!this._skipLoadingOverlay){
		this.api.showLoadingOverlay();
	}
	if (this._pages[page]) {
		// Page is in memory
		this._renderPage(page);
	} else {
		this._getPage(page)
			.then(page => this._renderPage(page))
			.catch(error => {
				console.log(error);
				alert('Error retrieving page');
			})
	}
}

/**
 * Renders a page on the grid
 *
 * @param page
 */
function renderPage(page) {
	if (this._currentPage === page) {
		// Hide viewport if auto refresh is not enabled
		if(!this._autoRefresh){
			this._hideViewport();
		}

		// Only render them if currently on that page
		this._rows = this._pages[page].rows;
		this.api.setRowData(this._rows);

		// Remove loader
		this.api.hideOverlay();

		if (this._rows.length === 0) {
			this.api.showNoRowsOverlay();
		}

		// Preserve scroll if requested
		if(this._preservedXScroll || this._preservedYScroll){
			const viewPort = this._domElement.querySelector('.ag-body-viewport')
			viewPort.scrollLeft = this._preservedXScroll;
			viewPort.scrollTop = this._preservedYScroll;

			// Clear preserved scroll values
			this._preservedXScroll = this._preservedYScroll = undefined;
		}

		// Update footer
		this._updateFooter();
	}
}

/**
 * Returns a promise that resolves after retrieving
 * the rows belonging to a page
 *
 * @param page
 * @return {Promise<unknown>}
 */
function getPage(page) {
	const startRow = page * this.paginationPageSize;

	return new Promise((resolve, reject) => {
		this._getRows(startRow).then(data => {
			let rows;
			let lastRowIndex;
			// noinspection JSUnresolvedVariable
			if (!data.rows || (data.rows.length === 0 && data.lastRowIndex === 0)) {
				rows = [];
				lastRowIndex = 0;
			} else {
				rows = data.rows;
				// noinspection JSUnresolvedVariable
				lastRowIndex = data.lastRowIndex;
			}

			// Store the page and last row index
			this._pages[page] = {
				rows,
			};

			this._totalRows = lastRowIndex;

			resolve(page, this._pages[page]);
		}).catch(e => {
			reject(e);
		})
	})


}

/**
 * Sets the row widths to show all cells content and fill viewport
 */

function updateRowWidths() {
	this.columnApi.autoSizeAllColumns();

	// Check row width
	const rowWidth = this._domElement
		.querySelector('.ag-center-cols-container')
		.getBoundingClientRect()
		.width;

	const viewPortWidth = this._domElement
		.querySelector('.ag-center-cols-viewport')
		.getBoundingClientRect()
		.width;

	// Fill viewport if needed
	if (rowWidth < (viewPortWidth - 1)) {
		// All cells now display their content fully but there is still space
		// left over on the container, expand them to fit it.

		// We want to preserve their width as min width, otherwise
		// sizeColumnsToFit may end up clipping some cells in certain cases
		this._domElement.querySelectorAll('.ag-cell').forEach(cell => {
			const minWidth = cell.clientWidth;
			const colId = cell.getAttribute('col-id');

			// Find the column definition for this cell
			const column = this.columnApi.getColumn(colId);
			if (column) {
				// Preserve its width
				column.getColDef().minWidth = minWidth;
			}
		})

		this.api.sizeColumnsToFit();
	}
}

export {initGridForPagination};
